import { render, staticRenderFns } from "./PredixCasting.vue?vue&type=template&id=3c35b8b1&scoped=true"
import script from "./PredixCasting.vue?vue&type=script&lang=js"
export * from "./PredixCasting.vue?vue&type=script&lang=js"
import style0 from "./PredixCasting.vue?vue&type=style&index=0&id=3c35b8b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c35b8b1",
  null
  
)

export default component.exports